import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ScreenState, Task, LeadInfo } from './types';
import { Landing } from './components/Landing';
import { Scoring } from './components/Scoring';
import { Gate } from './components/Gate';
import { Results } from './components/Results';
const DEFAULT_TASKS: Task[] = [{
  id: '1',
  name: 'Writing email campaigns',
  revenueImpact: null,
  timeSpent: 0,
  repeatability: null,
  isCustom: false
}, {
  id: '2',
  name: 'Building reporting dashboards',
  revenueImpact: null,
  timeSpent: 0,
  repeatability: null,
  isCustom: false
}, {
  id: '3',
  name: 'Posting to social media',
  revenueImpact: null,
  timeSpent: 0,
  repeatability: null,
  isCustom: false
}, {
  id: '4',
  name: 'Qualifying inbound leads',
  revenueImpact: null,
  timeSpent: 0,
  repeatability: null,
  isCustom: false
}, {
  id: '5',
  name: 'Taking meeting notes & follow-ups',
  revenueImpact: null,
  timeSpent: 0,
  repeatability: null,
  isCustom: false
}, {
  id: '6',
  name: 'Competitor & market research',
  revenueImpact: null,
  timeSpent: 0,
  repeatability: null,
  isCustom: false
}];
export function App() {
  const [screen, setScreen] = useState<ScreenState>('landing');
  const [tasks, setTasks] = useState<Task[]>(DEFAULT_TASKS);
  const [leadInfo, setLeadInfo] = useState<LeadInfo>({
    fullName: '',
    companyName: '',
    title: '',
    workEmail: '',
    linkedInUrl: ''
  });
  const handleRestart = () => {
    setTasks(DEFAULT_TASKS);
    setLeadInfo({
      fullName: '',
      companyName: '',
      title: '',
      workEmail: '',
      linkedInUrl: ''
    });
    setScreen('landing');
  };
  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20
    },
    in: {
      opacity: 1,
      y: 0
    },
    out: {
      opacity: 0,
      y: -20
    }
  };
  const pageTransition = {
    type: 'spring',
    stiffness: 100,
    damping: 20
  };
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {screen === 'landing' && <motion.div key="landing" initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="min-h-screen" data-id="element-2">
            <Landing onStart={() => setScreen('scoring')} data-id="element-3" />
          </motion.div>}

        {screen === 'scoring' && <motion.div key="scoring" initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="min-h-screen" data-id="element-4">
            <Scoring tasks={tasks} setTasks={setTasks} onComplete={() => setScreen('gate')} onRestart={handleRestart} data-id="element-5" />
          </motion.div>}

        {screen === 'gate' && <motion.div key="gate" initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="min-h-screen" data-id="element-6">
            <Gate leadInfo={leadInfo} setLeadInfo={setLeadInfo} onSubmit={() => setScreen('results')} onRestart={handleRestart} data-id="element-7" />
          </motion.div>}

        {screen === 'results' && <motion.div key="results" initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="min-h-screen" data-id="element-8">
            <Results tasks={tasks} data-id="element-9" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}